module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Quarter1":"Quarter 1","Quarter2":"Quarter 2","Quarter3":"Quarter 3","Quarter4":"Quarter 4"},"zh":{"Quarter1":"一季度","Quarter2":"二季度","Quarter3":"三季度","Quarter4":"四季度"},"mm":{"Quarter1":"Quarter 1","Quarter2":"Quarter 2","Quarter3":"Quarter 3","Quarter4":"Quarter 4"}}')
  delete Component.options._Ctor
}
